import React, { FC } from 'react';

import Modal, { ModalTransition } from '@atlaskit/modal-dialog';

import { Servidor } from 'model/ufc/Servidor';
import { BuscaServidoresSection } from './BuscaServidoresSection';


export interface BuscaServodoresModalProps {
  isAberto: boolean;
  onServidorSelected: (servidor: Servidor) => void;
  onClose: () => void;
}


export const BuscaServidoresModal: FC<BuscaServodoresModalProps> = ({isAberto, onServidorSelected, onClose}) => {
  return <ModalTransition>
    {isAberto &&
      <Modal
        onClose={onClose}
        heading='Busca de Servidores'
        width='x-large'
      >
        <BuscaServidoresSection onServidorSelected={onServidorSelected} onCancelar={onClose} />
      </Modal>
    }
  </ModalTransition>;
}